export enum TaskStatus {
  WAITING = 'waiting',
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  TIME_OUT = 'time out',
  ABORTED = 'aborted',
  DONE = 'done',
  ACCOUNTS_MAPPED = 'accounts mapped',
}

export const PROCESSING_STATUSES = [TaskStatus.WAITING, TaskStatus.RUNNING, TaskStatus.ACCOUNTS_MAPPED]

export enum TaskType {
  ACCOUNTS_LINK = 'link account',
  DEFAULT = 'default',
  EOD_SEARCH = 'eod search',
  REPOSITORY_IMPORT = 'repository import',
  REPOSITORY_EXPORT = 'repository export',
  SYNC_HOLDING_ACCOUNT = 'sync linked account',
  MARKET_DATA_SYNC = 'market data sync',
  ANALYTICS_COMPUTE = 'analytics compute',
  TRANSACTION_BATCH_IMPORT = 'transaction batch import',
  ASSET_BATCH_IMPORT = 'asset batch import',
}
